/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateCustomerCommand { 
    employeeId?: string | null;
    firstName: string;
    lastName: string;
    email?: string | null;
    phoneNumber?: string | null;
    companyId: number;
    role: number;
    sites: Array<number>;
    unlockCode?: string | null;
    taxId?: string | null;
    terminationDate?: string | null;
}

